<template>
  <figure
    ref="linkCard"
    class="card"
  >
    <AppLink
      class="flex"
      :to="link"
    >
      <img
        v-if="value?.img"
        :src="value.img"
        width="76"
        height="96"
        loading="lazy"
      />
      <figcaption class="content">
        <UiChip
          label="Ещё по теме"
          :size="Size.S"
        />
        <div class="content-text">
          <span
            v-if="value?.title"
            class="title"
            v-html="value.title"
          />&nbsp;
          <span
            v-if="value?.subtitle"
            class="subtitle"
            v-html="value.subtitle"
          />
        </div>
        <div
          v-if="time"
          class="time"
        >
          <IconBase
            name="icon-clock"
            color="--alias-color-icon-subtle"
            size="16"
          />
          <span
            class="time-text"
            v-html="time"
          />
        </div>
      </figcaption>
    </AppLink>
  </figure>
</template>

<script lang="ts" setup>
  import { UiChip, Size } from '@experience/core-chips-ui';

  import { computed } from 'vue';

  import type { LinkedArticle } from '@/features/articleContent/models/LinkedArticle';
  import IconBase from '@/shared/ui/iconBase/IconBase.vue';

  import { readingTime } from '@/shared/utils/time';

  export interface Props {
    value: LinkedArticle;
  }

  const props = defineProps<Props>();

  const time = computed(() => (props.value?.reading_time ? readingTime(props.value?.reading_time) : undefined));
  const link = computed(() => `/${props.value?.type}s/${props.value?.slug}/`);
</script>

<style lang="scss" scoped>
  .card {
    display: flex;
    width: 495px;
    padding: var(--alias-space-32, 32px) 0;

    @include mobile {
      width: 100%;
      padding: var(--alias-space-24, 24px) 0;
    }
  }

  .flex {
    display: flex;
  }

  img {
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }

  .content {
    margin-left: 16px;
    cursor: pointer;
  }

  .chips {
    padding: 0 6px;
    border-radius: 4px;
    background-color: var(--alias-color-background-subtler);
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }

  .content-text,
  .time {
    margin-top: 4px;
  }

  .time {
    display: flex;
    align-items: center;
    color: var(--alias-color-text-subtle);
    fill: var(--alias-color-icon-subtle);
  }

  .title,
  .subtitle {
    font-size: 14px;
    line-height: 20px;
  }

  .title {
    font-weight: 700;
  }

  .time-text {
    margin-left: 4px;
    color: var(--alias-color-text-subtle);
    font-size: 14px;
    line-height: 20px;
  }

  a {
    color: var(--alias-color-text-default);
    text-decoration: none;
  }
</style>
